<section mat-dialog-title>
  <span>
    @if (data) {
      Edit widget
    } @else {
      Add widget
    }
  </span>
  <button mat-dialog-close>
    <i class="icon-close"></i>
  </button>
</section>

<section
  [formGroup]="form"
  mat-dialog-content
>
  <div class="flex flex-row">
    <label class="input-main-label capitalize">
      Widget type*
    </label>
    <mat-form-field
      class="select-classic has-validation flex-1"
      appearance="outline"
    >
      <mat-select
        formControlName="type"
        panelClass="single-select-overlay"
        placeholder="Select widget type"
      >
        <mat-option value="buildingPlan">Building Plan</mat-option>
        <mat-option value="connectedDevices">Connected Devices</mat-option>
        <mat-option value="dataPoint">Data Point</mat-option>
        <mat-option value="deviceChart">Device Chart</mat-option>
        <mat-option value="devices">Devices</mat-option>
        <mat-option value="deviceStats">Device Stats</mat-option>
        <mat-option value="gauge">Gauge</mat-option>
        <mat-option value="map">Map</mat-option>
        <mat-option value="roomState">Room State</mat-option>
        <mat-option value="spaceDetails">Space Details</mat-option>
      </mat-select>
      <mat-icon
        class="arrow-down"
        matSuffix
      >keyboard_arrow_down
      </mat-icon>
      <mat-error>Input is not valid</mat-error>
    </mat-form-field>
  </div>

  @switch (form.value.type) {
    @case ('connectedDevices') {
      <avs-connected-devices-options
        (changed)="updateForm($event)"
        [config]="form.value.widgetConfig"
      />
    }
    @case ('buildingPlan') {
      <avs-li-location-options
        type="building"
        (changed)="updateForm($event)"
        [allRequired]="false"
        [config]="form.value.widgetConfig"
      />
    }
    @case ('dataPoint') {
      <avs-data-point-options
        (changed)="updateForm($event)"
        [config]="form.value.widgetConfig"
        [hideDateRangeInput]="true"
      />
    }
    @case ('deviceChart') {
      <avs-data-point-options
        (changed)="updateForm($event)"
        [config]="form.value.widgetConfig"
      />
    }
    @case ('devices') {
      <avs-li-location-options
        type="room"
        (changed)="updateForm($event)"
        [allRequired]="false"
        [config]="form.value.widgetConfig"
      />
    }
    @case ('deviceStats') {
      <avs-device-stats-options
        (changed)="updateForm($event)"
        [config]="form.value.widgetConfig"
      />
    }
    @case ('map') {
      <avs-li-location-options
        type="building"
        (changed)="updateForm($event)"
        [allRequired]="false"
        [config]="form.value.widgetConfig"
      />
    }
    @case ('roomState') {
      <avs-room-state-options
        (changed)="updateForm($event)"
        [config]="form.value.widgetConfig"
      />
    }
    @case ('spaceDetails') {
      <avs-li-location-options
        type="room"
        (changed)="updateForm($event)"
        [allRequired]="false"
        [config]="form.value.widgetConfig"
      />
    }
    @case ('gauge') {
      <avs-gauge-options
        (changed)="updateForm($event)"
        [config]="form.value.widgetConfig"
      />
    }
  }

  @if (form.value.widgetConfig) {
    <div class="flex flex-row">
      <label class="input-main-label capitalize">
        Widget name*
      </label>
      <mat-form-field
        class="input-classic flex-1"
        appearance="outline"
      >
        <input
          formControlName="name"
          matInput
          placeholder="Enter widget name"
        />
        <mat-error>Input is not valid</mat-error>
      </mat-form-field>
    </div>
  }
</section>

<mat-dialog-actions align="end">
  <button
    class="btn-transparent btn-medium font-bold mr-4"
    mat-dialog-close
  >
    CANCEL
  </button>
  <button
    class="btn-green btn-medium font-bold"
    (click)="onSubmit()"
    [disabled]="form.invalid"
  >
    @if (data) {
      <span>SAVE</span>
    } @else {
      <span>ADD</span>
    }
  </button>
</mat-dialog-actions>
